document.addEventListener('DOMContentLoaded', function () {
  // Keep a copy of all cards
  window.collabs = {
    cards: Array.from(document.querySelectorAll('[data-card]')),
    currentPage: 1,
  }

  setupPagination();
  setupDropdowns();
  setupSorting();
  setupFiltering();
});

function setupPagination() {
  const pagination = document.querySelector('[data-pagination]');
  const paginationButtons = pagination.querySelectorAll('.collaborations__pagination-pages button');
  const prev = pagination.querySelector('.prev');
  const next = pagination.querySelector('.next');
  let { total, maxPages, perPage } = pagination.dataset;

  // Convert to numbers
  total = parseInt(total);
  maxPages = parseInt(maxPages);
  perPage = parseInt(perPage);

  paginationButtons.forEach(button => {
    button.addEventListener('click', () => {
      if (!button.classList.contains('active')) {
        collabs.currentPage = parseInt(button.dataset.index);
        updateCardsDisplay();  // Update cards when a pagination button is clicked
      }
    });
  });

  prev && prev.addEventListener('click', () => {
    collabs.currentPage--;
    updateCardsDisplay();  // Update cards when the prev button is clicked
  });
  next && next.addEventListener('click', () => {
    collabs.currentPage++;
    updateCardsDisplay();  // Update cards when the next button is clicked
  });
}

function setupDropdowns() {
  const dropdowns = document.querySelectorAll('[data-dropdown]');

  dropdowns.forEach(dropdown => {
    const trigger = dropdown.querySelector('[data-dropdown-trigger]');

    trigger && trigger.addEventListener('click', () => dropdown.classList.toggle('active'));

    document.addEventListener('click', (e) => {
      if (!e.target.closest(`[data-dropdown="${dropdown.dataset.dropdown}"]`)) {
        dropdown.classList.remove('active');
      }
    });
  });
}

function setupSorting() {
  const sortEl = document.querySelector('[data-sort]');
  const sortOptions = sortEl.querySelectorAll('[data-sort-options] [data-sort-option]');

  sortOptions.forEach((option) => {
    option.addEventListener('click', () => {
      // Set all options to inactive
      sortOptions.forEach(option => option.classList.remove('active'));

      // Set the clicked option to active
      option.classList.add('active');

      // Close the dropdown
      sortEl.classList.remove('active');

      // Go to the first page; this sorts, filters and updates the cards
      collabs.currentPage = 1;
      updateCardsDisplay();
    });
  });
}

function setupFiltering() {
  const filterEl = document.querySelector('[data-filter]');
  const filterOptions = filterEl.querySelectorAll('[data-filter-options] [data-filter-option]');

  filterOptions.forEach((option) => {
    option.addEventListener('click', () => {
      // Set all options to inactive
      filterOptions.forEach(option => option.classList.remove('active'));

      // Set the clicked option to active
      option.classList.add('active');

      // Close the dropdown
      filterEl.classList.remove('active');

      // Go to the first page; this sorts, filters and updates the cards
      collabs.currentPage = 1;
      updateCardsDisplay();
    });
  });
}

function updateCardsDisplay() {
  let cards = collabs.cards.slice();
  const filterOption = document.querySelector('[data-filter-option].active').dataset.filterOption;
  const sortOption = document.querySelector('[data-sort-option].active').dataset.sortOption;
  const pagination = document.querySelector('[data-pagination]');
  let { total, maxPages, perPage } = pagination.dataset;

  total = parseInt(total);
  maxPages = parseInt(maxPages);
  perPage = parseInt(perPage);

  let filteredCards = cards;
  if (filterOption !== 'all') {
    filteredCards = cards.filter(card => {
      let cardFilterOptions = card.dataset.cardFilterOptions.split(' ');
      return cardFilterOptions.includes(filterOption);
    });
  }

  if (sortOption !== 'none') {
    filteredCards.sort((a, b) => sortOption === 'ascending'
      ? a.dataset.card.localeCompare(b.dataset.card)
      : b.dataset.card.localeCompare(a.dataset.card));
  }

  filteredCards.forEach(card => card.classList.add('hidden'));

  const offset = (collabs.currentPage - 1) * perPage;
  const limit = (maxPages > collabs.currentPage) ? offset + perPage : total;

  for (let i = offset; i < limit; i++) {
    filteredCards[i] && filteredCards[i].classList.remove('hidden');
  }

  updateDOM(filteredCards);
  updatePagination(filteredCards.length, perPage);
}

function updateDOM(cards) {
  const cardsContainer = document.querySelector('[data-cards-container]');
  cardsContainer.innerHTML = '';
  cards.forEach(card => cardsContainer.appendChild(card.cloneNode(true)));
}

function updatePagination(totalItems, itemsPerPage) {
  const pagination = document.querySelector('[data-pagination]');
  const paginationButtonsContainer = pagination.querySelector('.collaborations__pagination-pages');
  const paginationButtons = paginationButtonsContainer.querySelectorAll('button');
  const prev = pagination.querySelector('.prev');
  const next = pagination.querySelector('.next');

  // Remove existing pagination buttons
  paginationButtons.forEach(button => button.remove());

  // Calculate number of pages
  const numberOfPages = Math.ceil(totalItems / itemsPerPage);

  // Add new pagination buttons
  for (let i = 1; i <= numberOfPages; i++) {
    const button = document.createElement('button');
    button.textContent = i.toString();
    button.dataset.index = i;
    button.addEventListener('click', () => {
      if (!button.classList.contains('active')) {
        collabs.currentPage = parseInt(button.dataset.index);
        updateCardsDisplay();
      }
    });
    paginationButtonsContainer.appendChild(button);
  }

  // Set current page as active
  const currentButton = paginationButtonsContainer.querySelector(`button[data-index="${collabs.currentPage}"]`);
  if (currentButton) {
    currentButton.classList.add('active');
  }

  // Enable or disable prev/next buttons based on current page
  prev.disabled = collabs.currentPage === 1;
  next.disabled = collabs.currentPage === numberOfPages;
}
